<main>
  <div class="row">
    <div class="col-sm-12">
      <h1 class="text-primary mb-0">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.TitlePreStage' | translate}}</h1>
    </div>
  </div>

  <div class="col-sm-12 text-end">
    <button (click)="expandNewBeneficiary=!expandNewBeneficiary;expandNewItem(true)"
             [disabled]="estadoDevolvidoAoRemetente"
            [ngClass]="!expandNewBeneficiary ? '' : 'disabled'"
            aria-label="Nova entrada"
            type="button"
            class="btn btn-link">
      <span class="icon-add"></span> <span>{{ 'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.AddItemRepresentado' | translate}}</span>
    </button>
  </div>



  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col" class="icon" ></th>
        <th scope="col">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.HasPortugueseNationality' | translate}}</th>
        <!--<th scope="col">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.HasPortugueseNif' | translate}}</th>-->
        <th scope="col">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.Nif' | translate}}</th>
        <th scope="col">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.RepresentationType' | translate}}</th>
        <th scope="col">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.BenefitType' | translate}}</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let tableItem of model.beneficiaryList; let i = index">
        <tr *ngIf="isNotSender(tableItem) && (tableItem.beneficiaryName==null || isRepresentadoButNotBeneficiary(tableItem))" [ngClass]="expandedRowIndex == i ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)">
          <td  class="icon"
              [tooltip]="getStateText(tableItem.stateRL?.toString())"
              [style.color]="getStateColor(tableItem.stateRL?.toString())">
            <i style="font-size:20px" class="icon-user"></i>
          </td>
          <td>{{(tableItem.hasNacPT?.toString()=='true')?'Sim':'Não'}}</td>
          <!--<td>{{(tableItem.hasNIFPT?.toString()=='true')?'Sim':'Não'}}</td>-->
          <td>{{tableItem.NIF}}</td>
          <td>{{tableItem.representationType | dropdowns:'DropdownRepresentationType':dropdowns}}</td>
          <td>{{benefitLabelAppearingFunction(tableItem.survivalPensionBenefit, tableItem.reimbursementFuneralBenefit, tableItem.funeralAllowanceBenefit)}}</td>

          <td class="buttons-edit" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
            <button type="button" class="btn-icon" aria-label="Editar" [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic">
              <span class="p-1 text-primary " [ngClass]="getIconEditar(expandedRowIndex == i)"></span>
            </button>
            @if(estadoPendente?.toString()!='true'){
            <button type="button" class="btn-icon" aria-label="Apagar">
              <span class="icon-trash p-1" (click)="$event.preventDefault(); $event.stopPropagation();removeFromList(tableItem, i,$event)" [ngClass]="expandedRowIndex == i ? 'text-primary' : 'text-primary'"></span>
            </button>

            }
          </td>
        </tr>
        <tr *ngIf="expandedRowIndex == i" [collapse]="expandedRowIndex != i" [isAnimated]="false" class="table-active-bottom-border">
          <td class="p-0" colspan="7" id="collapseBasic">
            <div class=" p-4">
              <representados-list-table-edit-pre-stage [itemList]="model.beneficiaryList" [editIndex]="i"
                                                       [item]="tableItem" [dropdowns]="dropdowns"
                                                       [nifDeceased]="nifDeceased"
                                                       [nifRepresentanteLegal]="nifRepresentanteLegal"                                                      
                                                       [estadoPendente]="estadoPendente"
                                                     (listChanged)="onBeneficiaryChanged($event)"
                                                       [isBeneficiary]="isBeneficiary"
                                                      [stateCode]="stateCode"
                                                      [statePhase]="statePhase"
                                                     (isClosing)="isClosingAction()"  ></representados-list-table-edit-pre-stage>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
  <!-- TODO :  Find a better way to do this both the boolean cast and the input "binding"-->
  <input hidden [class.ng-invalid]="!hasOtherThanSender()" />
  <validation-message *ngIf="!hasOtherThanSender()" message="{{'ValidationMessages.atleastOneElement' | translate}}"></validation-message>

  <!--New table entry inputs-->
  <div *ngIf="expandNewBeneficiary" class="shadow  p-4 mb-4 mt-5">
    <div class="row">
      <div class="col-11">
        <h2 class="text-primary mb-0">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.SubTitlePreStage' | translate}}</h2>
      </div>
      <div class="col-1">
        <button type="button" class="close" aria-label="Fechar" (click)="expandNewBeneficiary=!expandNewBeneficiary">
          <span aria-hidden="true" class="p-1 icon-close text-primary"></span>
        </button>
      </div>
    </div>


    <representados-list-table-edit-pre-stage [dropdowns]="dropdowns"
                                           [itemList]="model.beneficiaryList"
                                                       [isBeneficiary]="isBeneficiary"
                                                      [stateCode]="stateCode"
                                                      [statePhase]="statePhase"
                                       
                                             [nifDeceased]="nifDeceased"
                                             [estadoPendente]="estadoPendente"
                                             [nifRepresentanteLegal]="nifRepresentanteLegal"
                                           (listChanged)="onBeneficiaryChanged($event)"
                                             (isClosing)="isClosingAction()"></representados-list-table-edit-pre-stage>

    
  </div>
</main>
